<template>
  <svg
    viewBox="0 0 96 96"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#4f2b1b">
      <path
        d="m48 19.84a34.09 34.09 0 1 1 -34.08 34.09 34.12 34.12 0 0 1 34.08-34.09m0-4a38.09 38.09 0 1 0 38.08 38.09 38.08 38.08 0 0 0 -38.08-38.09z"
      />
      <path
        d="m46.36 58.75a.34.34 0 0 0 -.23-.09c-4.41 0-10.07-.92-14.35.2a.34.34 0 0 0 -.24.24c-.8 3.18-.19 7.09-.19 10.36s-.64 7.21.2 10.36a.34.34 0 0 0 .24.24c2 .55 4.46.2 6.56.2 2.58 0 5.21.15 7.78 0a.35.35 0 0 0 .35-.35v-20.91a.36.36 0 0 0 -.12-.25z"
      />
      <path
        d="m64.69 69.43c0-3.26.63-7.21-.19-10.37a.35.35 0 0 0 -.25-.25c-4.29-1.09-9.9-.19-14.34-.19a.35.35 0 0 0 -.34.35v20.89a.3.3 0 0 0 .16.28.36.36 0 0 0 .18.07c4 .16 8 0 11.91 0 1.31 0 2.19.3 2.76-.78.48-.91.11-2.66.11-3.63z"
      />
      <path
        d="m46.27 47.18a.35.35 0 0 0 -.18-.06c-4.6-.23-9.29 0-13.9 0-3.16 0-2.36 1.69-2.36 4.57 0 2.72-.36 3.45 2.42 3.46 4.58 0 9.26.25 13.84 0a.35.35 0 0 0 .35-.35v-7.33a.3.3 0 0 0 -.17-.29z"
      />
      <path
        d="m66.17 50.56c0-2.7.36-3.44-2.4-3.46-4.62 0-9.24 0-13.86 0a.35.35 0 0 0 -.35.35v7.32a.3.3 0 0 0 .19.29.2.2 0 0 0 .11 0c4.59.3 9.31 0 13.91 0 3.23.06 2.4-1.62 2.4-4.5z"
      />
    </g>
    <path
      d="m63.17 31.7a6.69 6.69 0 0 0 -11.79-1.7 27.67 27.67 0 0 0 -2 3.41c-.54 1.05-1 2.15-1.48 3.14-.13-.31-.27-.61-.41-.91a28.07 28.07 0 0 0 -3.49-6.03 6.68 6.68 0 0 0 -11.83 3.93 6.54 6.54 0 0 0 2.89 5.86 35.55 35.55 0 0 0 9.4 4.87 10.73 10.73 0 0 0 3.42.58 9.62 9.62 0 0 0 3.44-.63 48.49 48.49 0 0 0 5.58-2.52 28.45 28.45 0 0 0 4.27-2.7 6.45 6.45 0 0 0 2-7.3zm-13.32 9.46c0-.17.09-.35.14-.52a32.72 32.72 0 0 1 4.07-8.52 3.33 3.33 0 0 1 2.77-1.56 3.39 3.39 0 0 1 1.64.44 3.33 3.33 0 0 1 1.67 2.6 3.07 3.07 0 0 1 -1.09 2.68 24.55 24.55 0 0 1 -3.43 2.27 28.66 28.66 0 0 1 -5.57 2.55zm-4 0a33.3 33.3 0 0 1 -7-3.34 17.63 17.63 0 0 1 -1.89-1.29 3.11 3.11 0 0 1 -1.25-3.37 3 3 0 0 1 2.55-2.49 3.85 3.85 0 0 1 .8-.09 2.92 2.92 0 0 1 2.49 1.42 29.55 29.55 0 0 1 4.3 9.15z"
      fill="#85c441"
    />
  </svg>
</template>
